/* Pinned-steps scroll driver.
 *
 * The section's surplus height (outer minus one viewport) is the pinned
 * "time"; progress through it picks the active step. Reading scroll and
 * toggling two class lists is all this does — the pinning itself is CSS
 * position: sticky, and the page always scrolls natively.
 */
(function () {
  'use strict';

  function init(el) {
    if (el.dataset.pinReady) return;
    el.dataset.pinReady = '1';

    var steps = Array.prototype.slice.call(el.querySelectorAll('[data-step]'));
    var panels = Array.prototype.slice.call(el.querySelectorAll('[data-panel]'));
    var count = steps.length;
    if (!count) return;
    var active = -1;
    var ticking = false;

    function update() {
      ticking = false;
      var rect = el.getBoundingClientRect();
      var surplus = el.offsetHeight - window.innerHeight;
      if (surplus <= 0) return;
      var progress = Math.min(1, Math.max(0, -rect.top / surplus));
      // 0.9999… guard: progress 1 must land on the LAST step, not count.
      var idx = Math.min(count - 1, Math.floor(progress * count));
      if (idx === active) return;
      active = idx;
      /* Three states, not one. The rail shows the arrived step in the bottom
       * slot, the one before it risen and dimmed, and nothing older — see the
       * stack block in section-pin-steps.css. Steps still ahead keep the base
       * style (faded, sitting low) and rise into place as they become active. */
      steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
        s.classList.toggle('is-prev', i === idx - 1);
        s.classList.toggle('is-gone', i < idx - 1);
      });
      panels.forEach(function (p, i) {
        p.classList.toggle('is-active', i === idx);
        p.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
      });
    }

    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function boot() {
    document.querySelectorAll('[data-pin]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
